import { Injectable } from '@angular/core';
import { User } from '@base-interfaces/user';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged, catchError } from 'rxjs/operators';
import { AuthRequests } from '@base/api/auth/auth.requests';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private _token = localStorage.getItem('eyrus-user-token') || null;
  private _refreshtoken = localStorage.getItem('eyrus-refresh-token') || null;
  private _user: User = JSON.parse(localStorage.getItem('eyrus-user') || '{}') || {};
  private _signUpProcess: any = JSON.parse(localStorage.getItem('eyrus-signProcess') || '[]') || [];
  private _accountId = localStorage.getItem('eyrus-accountId') || null;
  private _configurationKeys: any = JSON.parse(localStorage.getItem('eyrus-configuration-keys') || '{}') || {};

  private currentUserSubject = new BehaviorSubject<any>(this._user);
  private currentContractSubject = new BehaviorSubject<any>([]);
  private currentPermissionsSubj = new BehaviorSubject<any>([]);
  private currentProjectSubject = new BehaviorSubject<any>({});

  currentContract = this.currentContractSubject.asObservable().pipe(distinctUntilChanged());
  currentProject = this.currentProjectSubject.asObservable().pipe(distinctUntilChanged());
  currentUser = this.currentUserSubject.asObservable().pipe(distinctUntilChanged());
  currentPermissions = this.currentPermissionsSubj.asObservable().pipe(distinctUntilChanged());

  constructor(
    private auth: AuthRequests,
    private router: Router,
  ) { }

  set token(token) {
    localStorage.setItem('eyrus-user-token', token);
    this._token = token;
  }

  get token() {
    return this._token;
  }

  set refreshToken(token) {
    localStorage.setItem('eyrus-refresh-token', token);
    this._refreshtoken = token;
  }

  get refreshToken() {
    return this._refreshtoken;
  }

  set user(user: User) {
    localStorage.setItem('eyrus-user', JSON.stringify(user));
    this._accountId = user.accounts ? user.accounts[0].accountId.toString() : '';
    localStorage.setItem('eyrus-accountId', this._accountId);
    this._user = user;

    this.currentUserSubject.next(user);
  }

  get user() {
    return this._user;
  }

  get accountId() {
    //return this._accountId;
    const accountID = localStorage.getItem('eyrus-accountId');
    return accountID;
  }


  get signUpProcess() {
    return this._signUpProcess;
  }

  set signUpProcess(step: any) {
    const exists = this._signUpProcess.findIndex((e) => e.currentStep === step.currentStep)
    if (exists !== -1)
      this._signUpProcess[exists] = step;
    else
      this._signUpProcess.push(step);
  }

  clearSignUpProcess() {
    this._signUpProcess = [];
  }

  set contract(contract) {
    this.currentContractSubject.next(contract);
  }

  get project() {
    return this.currentContractSubject.getValue();
  }

  set project(project) {
    this.currentProjectSubject.next(project);
  }

  set accountPermission(permissions) {
    this.currentPermissionsSubj.next(permissions);
  }

  get configurationKeys() {
    return this._configurationKeys
  }

  set configurationKeys(payload: any) {
    localStorage.setItem('eyrus-configuration-keys', JSON.stringify(payload));
    this._configurationKeys = payload;
  }

  switchUserAccount(account) {
    this._accountId = account.accountId.toString();
    localStorage.setItem('eyrus-accountId', this._accountId);
  }

  async fetchConfigKeys() {
    const data = await this.auth.getConfigurationKeys().toPromise()
      .then((res) => {
        this.configurationKeys = res;
        return res;
      });
  }

  logout() {
    localStorage.clear();
    this.user = {};
    this.token = null;
    this.refreshToken = null;
    this.currentUserSubject.next([]);
    this.currentContractSubject.next([]);
    this.currentProjectSubject.next({});
    this.currentPermissionsSubj.next([]);
    localStorage.removeItem('eyrus-show-subheader');
    this.router.navigate(['/auth/login']);
  }

  initRefreshToken() {
    return this.auth.refreshToken(this.refreshToken);
  }
}
